<template>
  <div>
    <Tables ref="tableGrid"
        :columns="headTable"
        :showSearch="false"
        :showPrint="false"
        :showDownload="false"
        :showCheckInput="true"
        :showFullscreen="false"
        @check="checkAll"
        v-on:Load="onLoad"
    >
        <tr v-for="(obj,index) in dataTable" :key="index">
        <TableColumn :IsCustom="true" class="pl-3">
          <!-- Quem nao entra em lote fica com o checkbox travado e o motivo aparece ao passar o mouse.
               O tooltip mora no span porque input disabled nao dispara evento de mouse. -->
          <span :class="{ 'checkbox-bloqueado': !podeEntrarEmLote(obj) }" v-b-tooltip.hover :title="podeEntrarEmLote(obj) ? '' : motivoForaDoLote(obj)">
            <b-form-checkbox :id="obj.id" :name="`accept-${index}`"  :value="index" unchecked-value="" size="sm" :disabled="!podeEntrarEmLote(obj)"></b-form-checkbox>
          </span>
        </TableColumn>
        <TableColumn :IsText="true"   v-on:Edit="onSelect(obj)" :status="obj.status" :value="obj ? obj.solicitacaoNumero : 'N/D'" />
        <TableColumn :IsText="true"   v-on:Edit="onSelect(obj)" :status="obj.status" :value="obj.termoAnexoLog ? obj.termoAnexoLog.lote + ' Lote ' : 'N/D'" />
        <TableColumn  :IsDatetime="true" v-on:Edit="onSelect(obj)" :status="obj.status" :value="obj.dataSolicitacao" />
        <TableColumn :IsText="true"   v-on:Edit="onSelect(obj)" :status="obj.status" :value="obj.solicitante ? obj.solicitante.nome : ''" />
        <TableColumn :IsText="true"   v-on:Edit="onSelect(obj)" :status="obj.favorecido.demissao ? 0 : 1" :value="obj.favorecido ? obj.favorecido.nameCodigo : ''" />
        <TableColumn :IsText="true"   v-on:Edit="onSelect(obj)" :status="obj.status" :value="obj.obra ? obj.obra.referencia + ' - ' + obj.obra.localizacao : ''" />
        <TableColumn :IsText="true"   v-on:Edit="onSelect(obj)" :status="obj.status" :value="obj.responsavel ? obj.responsavel.nome : ''" />
        <TableColumn :IsText="true"   v-on:Edit="onSelect(obj)" :status="obj.status" :value="formatMoney(obj.valorSolicitado)" />
        <TableColumn :IsText="true"   v-on:Edit="onSelect(obj)" :status="obj.status" :value="obj.motivoViagem ? obj.motivoViagem.nome : ''" />
        <TableColumn :IsDatetime="true" v-on:Edit="onSelect(obj)" :status="obj.status" :value="obj.dataViagemInicio" />
        <TableColumn :IsDatetime="true" v-on:Edit="onSelect(obj)" :status="obj.status" :value="obj.dataViagemFim" />
        <TableColumn :IsText="true"   v-on:Edit="onSelect(obj)" :status="obj.status" :value="setFormaCityState(obj.cidadeOrigem)" />
        <TableColumn :IsText="true"   v-on:Edit="onSelect(obj)" :status="obj.status" :value="setFormaCityState(obj.cidadeDestino)" />
        <TableColumn :IsCustom="true" class="text-center">
            <b-badge  v-if="(obj.situacao >= 0 && obj.situacao < 3) || obj.situacao === -4" variant="warning" pill style="padding: 6px 10px 6px 10px;">{{getStatus(obj.situacao)}}</b-badge>
            <b-badge  v-if="obj.situacao >= 3" variant="success" pill style="padding: 6px 10px 6px 10px;">{{getStatus(obj.situacao)}}</b-badge>
            <b-badge  v-if="obj.situacao < 0 && obj.situacao !== -4" variant="danger" pill style="padding: 6px 10px 6px 10px;">{{getStatus(obj.situacao)}}</b-badge>
        </TableColumn>
        <TableColumn :IsDatetime="true"  v-on:Edit="onSelect(obj)" :status="obj.status" :value="obj.dataAprovacao" />
        <TableColumn :IsText="true"   v-on:Edit="onSelect(obj)" :status="obj.status" :value="obj.aprovador ? obj.aprovador.nome : 'N/D'" />
        <TableColumn :IsCustom="true" class="text-center">
          <span v-if="obj.motivoReprovacao" v-b-tooltip.hover :title="obj.motivoReprovacao"><i class="fas fa-comment-alt" style="font-size: 15px; color: #ff0000;"></i></span>
          <span>&nbsp;</span>
        </TableColumn>
        <TableColumn :IsCustom="true" class="text-center">
          <span class="text-third" v-if="obj.situacao === 3" v-b-tooltip.hover :title="'Clonar'" @click="onClone(obj)"><i class="fa fa-clone icone-grid"></i></span>
        </TableColumn>
      </tr>
       <template #header-card-actions>
        <div class="buttons-table-action">
          <button class="importaexcel mr-3" @click="showHistory"><i class="fas fa-history mr-1"></i> HISTORICO DE LOTE</button>
          <button class="importaexcel ml-2" @click="verificaLote"><i class="fas fa-file-excel mr-1"></i> GERAR LOTE</button>
          <button class="importaexcel ml-2" @click="ImportExcelByIds"><i class="fas fa-file-excel mr-1"></i> EXPORTAR</button>
          <button v-if="ultimoArquivoGerado" class="importaexcel ml-2" @click="baixarArquivoGerado(ultimoArquivoGerado)"><i class="fas fa-download mr-1"></i> BAIXAR LOTE GERADO</button>
        </div>
      </template>
    </Tables>
    <ModalHistory ref="history-lote-term" :empresaId="CompanySelected"></ModalHistory>

    <b-modal
      hide-footer
      centered
      :title="'Confirmação Para Gerar Lote'"
      size="sm"
      ref="Confirma-gera-lote"
      id="history-lote">
        <div id="body-poupp-con">
            <div class="body-modal-card d-flex flex-wrap justify-content-around">
              <div class="font-confirma">
                O lote será gerado apenas com os adiantamentos selecionados, deseja continuar ?
              </div>
              <div class="button-confirma">
                <div class="button-cancelado-corpo">
                  <button @click="fechaConfirmacaoLote" class="button-nao">Não</button>
                </div>
                <div>
                  <button @click="confimarLoteChecked()" class="button-sim">Sim</button>
                </div>
              </div>
            </div>
        </div>
    </b-modal>
  </div>
</template>

<script>
import TableTravelAdvance from './TableTravelAdvance'
export default TableTravelAdvance
</script>

<style scoped>
.checkbox-bloqueado {
    display: inline-block;
    cursor: not-allowed;
}
.button-sim {
    width: 5rem;
    border: transparent;
    height: 2rem;
    border-radius: 6px;
    background: #046437;
    color: white;
    font-weight: bold;
}
.button-nao {
    width: 5rem;
    border: transparent;
    height: 2rem;
    border-radius: 6px;
    background: #ef0000;
    color: white;
    font-weight: bold;
}
.button-cancelado-corpo{
  gap: 1rem;
}
.button-confirma{
  display: flex;
  gap: 1rem;
  margin-top: 2rem;
  justify-content: center;
}
.font-confirma{
  font-size: 15px;
  text-align: justify;
  color: #666666;
  font-family: 'segoe UI';
}

.body-modal-card{
  max-height: 75vh;
  overflow: auto;
}
.card-lote{
  border: 1px dashed black;
  height: 200px;
  min-height: 200px;
  border-radius: 10px;
  width: 200px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}
.card-download{
  position: absolute;
  top: 0px;
  right: 0px;
  background: green;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  border-radius: 0px 10px 0px 10px;
  cursor: pointer;
  width: 40px;
  color: white;
}
.card-header .card-actions a, .card-header .card-actions button{
  margin: 5px !important;
}
.importaexcel{
  width: 20% !important;
  height: 80%;
  margin-right: 10px !important;
  padding-bottom: 3px;
  padding: 0px !important;
  border-radius: 10px;
  font-size: 14px;
  font-weight: bold;
  color: white !important;
  background: green  !important;
  padding-left: 4px !important;
}
.icone-excel{
  font-size: 50px;
  color: green;
}
.card-footer-lote{
  bottom: 0;
  display: flex;
  justify-content: center;
  width: 100%;
  height: 25px;
  background: rgb(78, 78, 78);
  color: white;
  border-radius: 0px 0px 10px 10px;
  font-weight: bold;
  position: absolute;
  align-items: center;
}
.buttons-table-action{
  width: 50vw;
  display: flex;
  justify-content: right;
  align-items: center;
}
.importaexcel:hover {
  background: rgb(0, 160, 0) !important
}
</style>



// WEBPACK FOOTER //
// src/views/private/travelreimbursement/components/TableTravelAdvance/TableTravelAdvance.vue